var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canDelete)?_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.onDeleteClick}},[_c('i',{staticClass:"el-icon-delete"}),_vm._v(" 删除 ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }